import { render, staticRenderFns } from "./PaymentNewVdInfo.vue?vue&type=template&id=2670fef6&scoped=true"
import script from "./PaymentNewVdInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentNewVdInfo.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewVdInfo.vue?vue&type=style&index=0&id=2670fef6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670fef6",
  null
  
)

export default component.exports